import React, { useState } from "react";
import styled from "styled-components";
import SupportCompo from "../components/SupportCompo";
import Header from "../components/Header";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import MobileNav from "../components/MobileNav";

const Support = () => {
  const [faqs, setfaqs] = useState([
    {
      question: "What types of systems do you support ?",
      answer:
        "Money Manager is web app it will be working any systems browzer but if you want to download a desktop version on windows download x86, x64 version & for Ios download of ios version all version listed on our website",
      open: false,
    },
    {
      question: "How to raise a ticket of query ?",
      answer:
        "Money Manager is web app it will be working any systems browzer but if you want to download a desktop version on windows download x86, x64 version & for Ios download of ios version all version listed on our website",
      open: false,
    },
    {
      question: "How can we get imformation of money manager ?",
      answer:
        "Money Manager is web app it will be working any systems browzer but if you want to download a desktop version on windows download x86, x64 version & for Ios download of ios version all version listed on our website",
      open: false,
    },
    {
      question: "What types of systems do you support ?",
      answer:
        "Money Manager is web app it will be working any systems browzer but if you want to download a desktop version on windows download x86, x64 version & for Ios download of ios version all version listed on our website",
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setfaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  return (
    <div className="bg">
      <Header active="" active1="" active2="active" active3="" />
      <MobileNav />
      <SupportCompo />
      <FaqContainer>
        <h2>Frequently Asked Questions</h2>
        <FaqGrid>
          {faqs.map((faq, i) => (
            <Faq faq={faq} index={i} toggleFAQ={toggleFAQ} />
          ))}
        </FaqGrid>
      </FaqContainer>
      <Footer />
    </div>
  );
};

export default Support;

const FaqContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 4rem calc((100vw - 1200px) / 2);
  padding-top: 0rem;

  h2 {
    margin-bottom: 1rem;
    font-size: 45px;
    font-weight: 600;
    color: #20204f;
    line-height: 65px;
    margin-top: 5px;
    text-align: center;
  }
  @media only screen and (max-width: 991px) {
    h2 {
      margin-bottom: 1rem;
      font-size: 35px;
      font-weight: 600;
      color: #20204f;
      line-height: 45px;
    }
  }
`;

const FaqGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.5rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;
